import React from 'react';
import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import { OptionLabel } from '../OptionLabel';
import { CoreCheckboxProps } from './types';

export const Checkbox = React.forwardRef<HTMLLabelElement, CoreCheckboxProps>(
  (
    {
      children,
      label,
      helpText,
      tooltip,
      onChange,
      isDisabled,
      disabled,
      isInvalid,
      invalid,
      isReadOnly,
      readOnly,
      isIndeterminate,
      indeterminate,
      isChecked,
      checked,
      id,
      ...rest
    }: CoreCheckboxProps,
    ref: React.ForwardedRef<HTMLLabelElement>
  ) => {
    // zag-js seeds its part ids from `id` (the input becomes `checkbox:${id}:input`), so a literal id goes to
    // `ids.hiddenInput` to land on the <input> unprefixed. Indeterminate wins over an explicit checked/isChecked.
    const effectiveIndeterminate = isIndeterminate ?? indeterminate;
    const effectiveChecked = effectiveIndeterminate ? 'indeterminate' : (isChecked ?? checked);

    return (
      <ChakraCheckbox.Root
        ref={ref}
        disabled={isDisabled ?? disabled}
        invalid={isInvalid ?? invalid}
        readOnly={isReadOnly ?? readOnly}
        {...(effectiveChecked !== undefined ? { checked: effectiveChecked } : {})}
        {...(id ? { ids: { hiddenInput: id } } : {})}
        {...rest}
      >
        <ChakraCheckbox.HiddenInput onChange={onChange} />
        <ChakraCheckbox.Control />
        <ChakraCheckbox.Label>
          <OptionLabel label={label} helpText={helpText} tooltip={tooltip}>
            {children}
          </OptionLabel>
        </ChakraCheckbox.Label>
      </ChakraCheckbox.Root>
    );
  }
);

Checkbox.displayName = 'checkbox';
